export interface PreEarnQueueRes {
	depositQualified: boolean;
	inviteQualified: boolean;
	qualified: boolean;
	tradeQualified: boolean;
	lineUpNumber?: number;
}

export interface TradingType {
	name: string; // 交易类型名称
	tradingCount: number; // 交易数量
	tradingRate: number; // 交易比率
}

export interface Stock {
	symbol: string; // 股票符号
	name: string; // 股票名称
	tradingRate: number; // 交易比率
	tradingProfit: number; // 交易利润
	tradingProfitRate: number; // 交易利润率
	tradingCount?: number; // 交易次数
}

export interface UserActivity2023Response {
	userId: number; // 用户ID
	activeDays: number; // 活跃天数
	tradingDays: number; // 交易天数
	accumulateYield: number; // 整体盈亏
	accumulateYieldRank: number; // 盈亏排名
	accumulatedMiddleYield: number; // 收益中位数
	tradeWinRate: number; // 交易胜率
	mostTradeWinRate: number; // 最大交易胜率
	maxDayYield: number; // 最大日收益
	maxDayYieldDateTime: number; // 最大日收益时间戳
	closeOrderCount: number; // 平仓订单数
	globalDayYield: number; // 全局日收益率
	globalDayYieldDate: number; // 全局日期
	tradingTypes: TradingType[]; // 交易类型数组
	tradingCountStocks: Stock[]; // 交易股票数组
	profitStocks: Stock[]; // 盈利股票数组
	mostTradeType: TradingType; // 最多交易的品类
	mostTradeStock: Stock; // 最多交易的股票
	mostProfitStock: Stock; // 盈利最多的股票
	accumulateEarning: number; // 年度收益;
	accumulateEarningAvg: number; // 年度平均收益;
	accumulateYieldAvg: number; // 年度平均收益率;
}

export interface InviterModel {
	id: number;
	userId: number;
	avatarId: string;
	avatar: string;
	nickname: string;
	introduction: string;
	createTime: string;
	updateTime: string;
}

export enum StockRewardStatus {
	UNQUALIFIED,
	PENDING,
	REDEEMED,
}

export interface InviterReward {
	id: number;
	userId: number;
	promotionId: number;
	questType: string;
	userType: string;
	rewardId: string;
	rewardQuantity: number;
	price: object;
	currency: string;
	rewardType: string;
	rewardStatus: StockRewardStatus;
	accumulatedCount: number;
	accumulatedDeposit: object;
	recordId: number;
	createTime: string;
	updateTime: string;
	issueTime: string;
	claimTime: string;
}

export interface InviterResponse {
	invitee: InviterModel[];
	inviterReward: InviterReward;
}

export interface InviteeRegisterTime {
	inviteeRegisterTime: string;
}

export interface InviteeResponse {
	inviter: InviterModel;
	inviteeReward: InviterReward;
	inviteeRegisterTime: string;
	inviterCode: string;
	inviterIsOpen: boolean; // 邀请人是否开户 用于判断邀请人的邀请码是否有效
}

export interface InviteCountResponse {
	inviteCount: number; // 邀请人数
	participateCount: number; // 参与计数
}

export interface StockRebateActivityRes {
	enabled: boolean; // 中途终止
	endTime: number; // 结束时间
	participateCount: number;
	promotionId: number; // 活动id
	startTime: number; // 开始时间
	inviteeReward: InviterReward;
}

export enum HotActivities {
	trump_watchlist_activity = "trump_watchlist_activity",
	ai_app_watchlist_activity = "ai_app_watchlist_activity",
	crypto_btw_watchlist_activity = "crypto_btw_watchlist_activity",
}

export interface AutoCopyUserDataRes {
	hidden: boolean;
	userId: number;
	name: string;
	avatar: string;
	monthYieldRate: number;
	yearYieldRate: number;
	moments: {
		id: number;
		momentId: number;
		userId: number;
		type: number;
		orderId: string;
		orderAmount: number;
		orderPrice: number;
		instrument: string;
		market: string;
		openClose: string;
		copyOrderId: string;
		symbol: string;
		watchlistId: number;
		followUserId: number;
		status: string;
		progressCount: number;
		fullClosing: boolean;
		heavily: boolean;
		count: number;
		hideDetails: boolean;
	}[];
	positions: {
		symbol: string;
		positionPercentage: number;
	}[];
}

export interface PortalWatchlistRes {
	id: number;
	watchlistId: string;
	watchlistName: string;
	userId: string;
	allowFollow: boolean;
	availability: number;
	followerCount: number;
	symbolCount: number;
	viewRight: number;
	dailyProfit: number;
	grossProfit: number;
	coverId: string;
	coverUrl: string;
	authorSays: string;
	logos: string[];
	changePercent: number;
}

export interface GenZQuestionRes {
	roundId: number;
	questions: {
		questionId: number;
		question: string;
	}[];
}

export interface GenZQQuestion {
	title: string;
	options: {
		text: string;
		value: number;
	}[];
}

export interface GenZQuestionReq {
	answer: number;
	questionId: number;
}

export interface GenQAOptionModel {
	text: string;
	value: number;
}

export interface GenQAModel {
	title: string;
	options: GenQAOptionModel[];
}

export enum PromotionTypeEnum {
	PULL_NEW = "PULL_NEW",
	IQIYI = "IQIYI",
	TRADING = "TRADING",
	DEPOSIT = "DEPOSIT",
	NEW_DEPOSIT = "NEW_DEPOSIT",
	QUIZ_REWARD = "QUIZ_REWARD", // GenZ答题活动
	BOBBY_ORDER_COMMISSION_REDUCTION = "BOBBY_ORDER_COMMISSION_REDUCTION", // Bobby下单佣金减免
}

export interface RewardModel {
	available: number;
	createTime: number;
	currency: string;
	id: number;
	minCount: number;
	minDeposit: number;
	price: number;
	promotionId: number;
	questType: number;
	rewardAmount: number;
	rewardId: string;
	rewardQuantity: number;
	rewardType: number;
	updateTime: number;
	userType: number;
}

export interface PromotionActivity {
	promotionId: string;
	promotionName: string;
	available: number;
	promotionType: string;
	createTime: number;
	updateTime: number;
	beginTime: number;
	endTime: number;
	rewards: RewardModel[];
}

export interface UserRankModel {
	userId: number;
	nickname: string;
	avatar: string;
	rounds: number;
	score: number;
	rank: number;
}

export interface UserRankingRes {
	promotionId: number;
	users: UserRankModel[];
	leaderboardTimes: string;
}

export interface GroupRankingRes {
	promotionId: number;
	users: {
		groupId: number;
		name: string;
		rounds: number;
		score: number;
	}[];
	leaderboardTimes: string;
}

export interface ActivityGenZRewardRes {
	id: number;
	userId: number;
	promotionId: number;
	questType: string;
	userType: string;
	rewardId: string;
	rewardQuantity: number;
	price: object;
	currency: string;
	rewardType: number;
	rewardStatus: string;
	accumulatedCount: number;
	accumulatedDeposit: object;
	recordId: string; // COMMISSION 佣金
	createTime: string;
	updateTime: string;
	issueTime: string;
	claimTime: string;
}

export interface AddressModel {
	recipient: string;
	contact: string;
	address: string;
}
